import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table bets report view.
 * @extends JetView
 */
export default class recordTableBetsReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        // Window for displaying filter details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails2',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles del Ticket'), // Ticket details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable',
                id: 'dtDetails2', // DataTable for ticket details
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    {
                        id: 'Id',
                        header: _('Ticket Det Id'), // Column header for Ticket Det Id
                        width: 100,
                        sort: 'int', // Sorting type
                    },
                    {
                        id: 'TicketId',
                        header: _('Ticket ID'), // Column header for Ticket ID
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'Description',
                        header: _('Descripción'), // Column header for Description
                        width: 250,
                        sort: 'int',
                    },
                    {
                        id: 'Market',
                        header: _('Market'), // Column header for Market
                        width: 100,
                        sort: 'int',
                    },
                    { id: 'Option', header: 'Option', width: 200, sort: 'int' }, // Column header for Option
                    {
                        id: 'Odds',
                        header: _('Odds'), // Column header for Odds
                        width: 100,
                        format: webix.i18n.numberFormat, // Number formatting for Odds
                        sort: 'int',
                    },
                ],
            },
        });

        // Main DataTable configuration
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            columns: [
                {
                    id: 'Id',
                    header: _('Ticket Det Id'), // Column header for Ticket Det Id
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'TicketId',
                    header: _('Ticket ID'), // Column header for Ticket ID
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: _('Descripción'), // Column header for Description
                    width: 250,
                    sort: 'int',
                },
                { id: 'Market', header: _('Market'), width: 100, sort: 'int' }, // Column header for Market
                { id: 'Option', header: 'Option', width: 200, sort: 'int' }, // Column header for Option
                {
                    id: 'Odds',
                    header: _('Odds'), // Column header for Odds
                    width: 100,
                    format: webix.i18n.numberFormat, // Number formatting for Odds
                    sort: 'int',
                },
            ],
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager ID
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        var url = devConfig.geturlApi() + 'null/Report/GetBetHistoryDetail'; // API URL for fetching bet history details
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID
            grid.clearAll(); // Clear existing grid data
            grid.load(url + '?id=' + idUser); // Load grid data based on user ID
            $$('dtDetails2').clearAll(); // Clear details DataTable
            $$('dtDetails2').load(url + '?id=' + idUser); // Load details DataTable based on user ID
        });
    }
}

// FILE DOCUMENTED
